import type { FC } from "react";
import { Flex } from "../../../layout/flex/Flex";
import { Box } from "../../../layout/box/Box";

type SwipeCarouselPaginationProps = {
    numOfSlides: number;
    activeIndex: number;
};

export const SwipeCarouselPagination: FC<SwipeCarouselPaginationProps> = ({
    numOfSlides,
    activeIndex,
}) => {
    return (
        <Flex
            display={{ base: "flex", lg: "none" }}
            gap={2}
            justify={"center"}
            position={"absolute"}
            bottom="4"
            zIndex={1}
            width={"100%"}
        >
            {Array.from({ length: numOfSlides }, (_, index) => ({ slideNumber: index + 1 })).map(
                ({ slideNumber }) => (
                    <Box
                        key={slideNumber}
                        h="3px"
                        w={4}
                        bgColor={activeIndex === slideNumber - 1 ? "black" : "gray.150"}
                    ></Box>
                )
            )}
        </Flex>
    );
};

SwipeCarouselPagination.displayName = "SwipeCarouselPagination";
